import { writable } from 'svelte/store';
import type { ManageAPI } from "~/manage-api/types";
import type { StoresKey } from "~/stores";

const browser = typeof window !== 'undefined';

// Global store for the offer modal
export const currentOfferId = writable<number>(0); // 0 means closed, any other number is the offer ID
export const currentOfferDetails = writable<ManageAPI.Offer | null>(null); // Store the complete offer object
export const currentRequestStoreKey = writable<StoresKey | null>(null);

// Helper functions to open and close the global modal
export function openOfferModal(
  offerId: number, 
  offerDetails: ManageAPI.Offer, 
  requestStoreKey: StoresKey
): void {
  currentOfferId.set(offerId);
  currentOfferDetails.set(offerDetails);
  currentRequestStoreKey.set(requestStoreKey);
  
  // Add class to html element and prevent scrolling
  if (browser) {
    document.documentElement.classList.add('demo2025-modal-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }
}

export function closeOfferModal(): void {
  currentOfferId.set(0);
  currentOfferDetails.set(null);
  // We don't reset requestStoreKey as it might be needed again
  
  // Remove class from html element and restore scrolling
  if (browser) {
    document.documentElement.classList.remove('demo2025-modal-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
}